// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth--container {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n}\n\n.auth--white_background {\n  width: 100%;\n  height: 800px;\n  margin-top: 100px;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 960px) {\n  .auth--container {\n    width: 92vw;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
